import styled from "styled-components/native"
import FontAwesome from 'react-native-vector-icons/FontAwesome';

export const Container = styled.View`
    height: 70px;
    width: 100%;
    background: #ffffff;
    shadow-opacity: 0.3;
    shadow-radius: 5px;
    shadow-color: #000000;
    shadow-offset: 0px 0px;
    elevation: 1;
    display: flex;
    flex-direction: row;
    padding: 10px;
`

export const Input = styled.TextInput`
    flex: 1;
    border: 2px solid #F5F6F8;
    border-radius: 5px;
    font-size: 14px;
    color: #545A60;
    padding: 10px;
    padding-top: 15px;
`

export const Button = styled.TouchableOpacity`
    font-size: 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    cursor: pointer;
`